/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from '../img/swb-logo-heart.png'
import login from '../img/create-account.png'
import { useTheme } from '../context/ThemeProvider'
import { Link } from 'react-router-dom'

import axios from '../api/axios'
import useAuth from '../hooks/useAuth'

const EMAIL_REGEX =
  /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,12})$/
const FORGOT_PWD_URL = '/forgot-password'

const FindOrg = () => {
  const theme = useTheme()
  const errRef = useRef()
  const navigate = useNavigate()
  const inputRef = useRef()
  const logo = theme?.logo
  const { orgDetails, setOrgDetails, bypassOrg } = useAuth()

  const [reference, setReference] = useState('')
  const [confirmed, setConfirmed] = useState(false)
  
  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(false)

  const [errMsg, setErrMsg] = useState('')
  const [success, setSuccess] = useState(false)

  const [isSearchingSchool, setIsSearchingSchool] = useState(true)
  const [schoolQuery, setSchoolQuery] = useState('')
  const [schoolResults, setSchoolResults] = useState([])
  const [isLoadingSchools, setIsLoadingSchools] = useState(false)

  useEffect(() => {
    const result = EMAIL_REGEX.test(email)
    setValidEmail(result)
  }, [email])

  useEffect(() => {
    setErrMsg('')
  }, [email, schoolQuery, reference])

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [isSearchingSchool])

  useEffect(() => {
    if (orgDetails && !confirmed) {
      setOrgDetails(null)
    }
  }, [])

  useEffect(() => {
    if (!isSearchingSchool || schoolQuery.trim().length < 2) {
      setSchoolResults([])
      return
    }

    const delayDebounceFn = setTimeout(async () => {
      setIsLoadingSchools(true)
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_KIS_BASE_URL}/api/v1/school-search/${encodeURIComponent(schoolQuery)}/AdmxJxJxB942LZNAANMOMqyG4AtOcf7l`
        )
        setSchoolResults(Array.isArray(response.data) ? response.data.filter((school) => (school.edustatus ?? '').toLowerCase() !== 'closed') : (response.data.data.filter((school) => (school.edustatus ?? '').toLowerCase() !== 'closed') ?? response.data.data) || [])
      } catch (error) {
        console.error("Error fetching schools:", error)
        setSchoolResults([])
      } finally {
        setIsLoadingSchools(false)
      }
    }, 400)

    return () => clearTimeout(delayDebounceFn)
  }, [schoolQuery, isSearchingSchool])

  const handleFindOrg = async (e) => {
    e.preventDefault()
    if (!reference.trim()) return setErrMsg('Please enter a reference.')

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_KIS_BASE_URL}/api/v2/validate-token`,
        {
          token: reference,
        }
      )

      const data = res.data

      if (!data.valid) {
        setErrMsg('Invalid organisation reference.')
        setOrgDetails(null)
        return
      }
      setOrgDetails({
        name: data.entity_name || 'Unknown organisation',
        postcode: data.entity_postcode || '',
        orgId: data.entity_id || '',
        valid: data.valid || false,
        trust_id: data.trust_id || null,
        trust_name: data.trust_name || null,
        trust_urn: data.trust_urn || null,
      })

      setErrMsg('')
    } catch (error) {
      setErrMsg('No organisation found with that reference.')
      setOrgDetails(null)
    }
  }

  const handleSelectSchool = (school) => {
    setOrgDetails({
      name: school.name || school.entity_name,
      postcode: school.postcode || school.entity_postcode || '',
      orgId: school.id || school.entity_id || '',
      valid: true,
      trust_id: school.trust_id || null,
      trust_name: school.trust_name || null,
      trust_urn: school.trust_urn || null,
    })
    setSchoolQuery('')
    setSchoolResults([])
  }

  const handleConfirm = () => {
    setOrgDetails({
      name: orgDetails.name,
      postcode: orgDetails.postcode,
      orgId: orgDetails.orgId,
      trust_id: orgDetails.trust_id || null,
      trust_name: orgDetails.trust_name || null,
      trust_urn: orgDetails.trust_urn || null,
    })
    navigate('/create-account/step-2', { state: { ...orgDetails } })
  }

  const resetFormState = () => {
    setOrgDetails(null)
    setConfirmed(false)
    setReference('')
    setSchoolQuery('')
    setSchoolResults([])
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center px-8 relative"
      style={{ backgroundImage: `url(${login})` }}
    >
      <div className="max-w-lg w-full space-y-4 md:space-y-6 py-8 px-4 md:absolute md:top-[15%] md:left-[15%]">
        <div className="pt-16 md:pt-0 flex items-center gap-3 pb-2 leading-tight tracking-wider text-[#360F41] dark:text-white">
          <img src={logo} alt="SWB Logo" className="h-20 w-auto" />
          <div>
            {theme.brand === 'swb' ? (<h1 className="text-2xl md:text-3xl font-bold">
              School Wellbeing <br /> Staff Portal
            </h1>) : (
              <h1 className="text-2xl md:text-3xl font-bold text-[#171960]">
              Be Well Support <br /> Staff Portal
            </h1>
            )}
            <h2 className="text-sm md:text-base font-medium">
              Find your Organisation
            </h2>
          </div>
        </div>

        <p
          ref={errRef}
          className={errMsg ? 'errmsg text-red-600 text-sm' : 'offscreen'}
          aria-live="assertive"
        >
          {errMsg}
        </p>

        <div className="space-y-4">
          
          {isSearchingSchool && !orgDetails && (
            <div className="space-y-3">
              <div>
                <label htmlFor="schoolSearch" className="block mb-2 text-sm font-medium text-gray-700">
                  Search for your School
                </label>
                <input
                  type="text"
                  ref={inputRef}
                  id="schoolSearch"
                  value={schoolQuery}
                  onChange={(e) => setSchoolQuery(e.target.value)}
                  placeholder="Type school name or postcode..."
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5 focus:ring-1 focus:ring-violet-400 focus:outline-none"
                />
              </div>

              {/* Scrollable dropdown list for results */}
              {schoolQuery.trim().length >= 2 && (
                <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg bg-white divide-y divide-gray-100 shadow-md">
                  {isLoadingSchools && (
                    <div className="p-3 text-sm text-gray-500 text-center animate-pulse">Searching...</div>
                  )}
                  {!isLoadingSchools && schoolResults.length === 0 && (
                    <div className="p-3 text-sm text-gray-500 text-center">No matching schools found</div>
                  )}
                  {!isLoadingSchools && schoolResults.map((school) => (
                    <button
                      key={school.id || school.entity_id}
                      type="button"
                      onClick={() => handleSelectSchool(school)}
                      className="w-full text-left px-4 py-3 hover:bg-violet-50 transition text-sm flex flex-col gap-0.5"
                    >
                      <span className="font-semibold text-[#360F41]">{school.urn} - {school.name}</span>
                      {school.postcode && <span className="text-xs text-gray-500">{school.postcode}</span>}
                    </button>
                  ))}
                </div>
              )}

              <div className="text-center pt-2">
                <button
                  type="button"
                  onClick={() => { resetFormState(); setIsSearchingSchool(false); }}
                  className="text-xs text-gray-500 font-medium hover:text-violet-400 hover:underline"
                >
                  Do you have an organisation reference? Click here
                </button>
              </div>
            </div>
          )}

          {!isSearchingSchool && !orgDetails && (
            <form onSubmit={handleFindOrg} className="space-y-4">
              <div>
                <label htmlFor="org" className="block mb-2 text-sm font-medium text-gray-700">
                  Organisation Reference
                </label>
                <input
                  type="text"
                  ref={inputRef}
                  id="org"
                  value={reference}
                  onChange={(e) => setReference(e.target.value)}
                  required
                  placeholder="Enter reference token"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg transition"
              >
                Find Organisation
              </button>
              
              <div className="text-center pt-2">
                <button
                  type="button"
                  onClick={() => { resetFormState(); setIsSearchingSchool(true); }}
                  className="text-xs text-gray-500 font-medium hover:text-violet-400 hover:underline"
                >
                  &larr; Back to search by school name
                </button>
              </div>
            </form>
          )}

          {orgDetails && (
            <div className="space-y-4">
              <div className="bg-violet-50 border border-violet-300 rounded p-4 text-sm text-[#360F41]">
                <p className="font-semibold">Organisation Found:</p>
                <p className="text-base font-bold mt-1">{orgDetails.name}</p>
                {orgDetails.postcode && <p className="text-gray-600 mt-0.5">{orgDetails.postcode}</p>}
                <button
                  type="button"
                  onClick={handleConfirm}
                  className="mt-4 w-full sm:w-auto bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-6 rounded-lg transition shadow-sm"
                >
                  Confirm & Continue
                </button>
              </div>

              <button
                type="button"
                onClick={resetFormState}
                className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-2 px-4 rounded-lg transition"
              >
                Not your Organisation? Try Again
              </button>
            </div>
          )}

          <div className="mt-6 text-xs text-gray-500 font-medium pt-2">
            <Link to="/login" className="hover:text-violet-400">
              Already have an account? Log in here
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FindOrg